import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatadogComponent } from './datadog/datadog.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import {FormsModule} from '@angular/forms';
import { SafePipe } from './safe.pipe';
import {MatDialogModule, MatFormFieldModule, MatSelectModule, MatSlideToggleModule} from '@angular/material';

@NgModule({
  declarations: [DatadogComponent],
  exports: [
    DatadogComponent
  ],
    imports: [
        CommonModule,
        AngularMultiSelectModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatDialogModule
    ]
})
export class MonitoringModule { }
